<template>
  <div
    class="c-cbr-MapOverlay showMap"
    @click="$emit('close')">
    <div
      :class="['c-cbr-MapOverlay-inner',$style.showMapInner]"
      @click.stop.prevent>
      <div :class="['c-cbr-MapOverlay-searchBox',$style.searchBoxDiv]">
        <h1
          :style="{color:pageTextColor}"
          class="c-cbr-MapOverlay-searchBoxHeader">
          {{ $t('parcelshop.headline') }}
        </h1>

        <div
          v-if="!searchDivMinimized"
          class="c-cbr-MapOverlay-searchBoxForm">
          <div
            :style="{color:pageTextColor}"
          >{{ $t('parcelshop.subheadline') }}</div>
          <form
            action
            data-vv-scope="mapSearchFormData"
            @submit.prevent>
            <div class="c-cbr-FormField-col">
              <label
                :style="{color:fieldTextColor}"
                class="c-cbr-FormField-label"
                for="address"
              >
                {{ `${$t('form.address')} (${$t('form.street')} + ${$t('form.city')}/${$t('form.postal_code')})` }}
                <span
                  v-if="addressHasError"
                  class="c-cbr-FormField-error"
                >{{ $t('error.mandatory_field') }}</span>
              </label>

              <input
                id="address"
                v-model="address"
                :class="['c-cbr-FormField-input', {'is-error': addressHasError }]"
                name="street"
                type="text"
                @keyup.enter="search()"
              >
            </div>
            <div :class="$style.dropdown">
              <div class="c-cbr-FormField-col">
                <label
                  :style="{color:fieldTextColor}"
                  class="c-cbr-FormField-label"
                  for="country-select"
                >
                  {{ $t('form.country') }}
                  <span
                    v-if="countryHasError"
                    class="c-cbr-FormField-error"
                  >{{ $t('error.mandatory_field') }}</span>
                </label>
                <div
                  :class="['c-cbr-FormField-select-wrapper',{'is-error': countryHasError }]">
                  <select
                    id="country-select"
                    v-model="selectedCountry"
                    class="c-cbr-FormField-input"
                    @change="setCountry($event.target.value)"
                  >
                    <option
                      v-for="(v, k) in getCountryList"
                      :key="k"
                      :value="v"
                      selected>{{ v }}</option>
                  </select>
                </div>
              </div>

              <div class="c-cbr-FormField-col">
                <label
                  :style="{color:fieldTextColor}"
                  class="c-cbr-FormField-label"
                  for="distance-select"
                >{{ $t('form.distance') }}</label>
                <div class="c-cbr-FormField-select-wrapper">
                  <select
                    id="distance-select"
                    v-model="distance"
                    class="c-cbr-FormField-input"
                    @change="search()"
                  >
                    <option
                      v-for="(option, key) in distanceOptions"
                      :key="key"
                      :value="option.value"
                    >{{ option.text }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div :class="$style.buttonDiv">
              <obj-button
                :is-active="true"
                :is-wide="true"
                class="o-button"
                @click="search()"
              >{{ $t('parcelshop.search') }}</obj-button>
            </div>
          </form>
        </div>

        <div v-else>
          <div :class="$style.addressField">
            <div>
              <b>
                <img
                  :style="{'max-height':'13px'}"
                  alt="Marker icon"
                  src="/assets/marker-icon.png"
                >
                {{ $t('parcelshop.your_address') }}
              </b>
            </div>
            <div>
              <obj-link
                aligned="right"
                @click="maximiseSearchDiv"
              >{{ $t('parcelshop.search_more') }}</obj-link>
            </div>
          </div>
          {{ address }} , {{ selectedCountry }}
          <hr >
        </div>
      </div>

      <div
        v-if="!countryHasParcelShops && !dropShops && showHint"
        :class="['c-cbr-MapOverlay-noResults',$style.errorMsg]">
        <span>{{ $t('return.no_parcelshops_yet_info') }}</span>
        <span :class="$style.sorryMsg">
          <p>
            <img
              src="/assets/pin.svg"
              style="height: 15px; width: 20px;"
            >
            <obj-link-default
              v-if="getSelectedCountryAlpha2Code === 'GB'"
              :href="'' + getSelectedCountryURL + ''"
              target="_blank"
              v-html="$t('return.uk_external_shops_link')"
            />
            <obj-link-default
              v-else-if="getSelectedCountryAlpha2Code === 'FR'"
              :href="'' + getSelectedCountryURL + ''"
              target="_blank"
              v-html="$t('return.fr_external_shops_link')"
            />
            <obj-link-default
              v-else-if="getSelectedCountryAlpha2Code === 'FI'"
              :href="'' + getSelectedCountryURL + ''"
              target="_blank"
              v-html="$t('return.fi_external_shops_link')"
            />
            <obj-link-default
              v-else-if="getSelectedCountryAlpha2Code === 'IT'"
              :href="'' + getSelectedCountryURL + ''"
              target="_blank"
              v-html="$t('return.it_external_shops_link')"
            />
            <obj-link-default
              v-else-if="getSelectedCountryAlpha2Code === 'SI'"
              :href="'' + getSelectedCountryURL + ''"
              target="_blank"
              v-html="$t('return.si_external_shops_link')"
            />
            <obj-link-default
              v-else
              :href="'' + getSelectedCountryURL + ''"
              target="_blank"
              v-html="$t('return._external_shops_link')"
            />
          </p>
        </span>

      </div>
      <div
        v-else-if="!dropShops"
        :class="['c-cbr-MapOverlay-noResults',$style.errorMsg]">
        <span
          v-if="getSelectedCountryAlpha2Code === 'FR'"
          v-html="$t('return.fr_no_parcelshop_nearby_psf')" />
        <span
          v-else-if="getSelectedCountryAlpha2Code === 'IT'"
          v-html="$t('return.it_no_parcelshop_nearby_psf')" />
        <span
          v-else-if="getSelectedCountryAlpha2Code === 'FI'"
          v-html="$t('return.fi_no_parcelshop_nearby_psf')" />
        <span
          v-else-if="getSelectedCountryAlpha2Code === 'SI'"
          v-html="$t('return.si_no_parcelshop_nearby_psf')" />
        <span
          v-else-if="getSelectedCountryAlpha2Code === 'GB'"
          v-html="$t('return.uk_no_parcelshop_nearby_psf')" />
        <span
          v-else
          v-html="$t('return.no_parcelshop_nearby_psf')" />
      </div>

      <div v-else-if="pendingRequests > 0">
        <obj-spinner />
      </div>

      <template v-else>
        <div :class="['c-cbr-MapOverlay-results',$style.resultsDiv]">
          <div
            id="c-cbr-MapOverlay-results-shopList"
            class="c-cbr-MapOverlay-results-shopList">
            <cbr-drop-shop-mini
              v-for="dropShop in dropShops.slice(0,resultLimit)"
              :id="dropShop.id"
              :key="dropShop.id"
              :drop-shop="dropShop"
              :selected="dropShop.id === selectedDropShop.id"
            />

            <div
              v-if="resultLimit < dropShops.length"
              :class="$style.showMore">
              <obj-button
                :is-active="true"
                :is-wide="true"
                class="o-button"
                @click="showMore()"
              >{{ $t("btn.show_more") }}</obj-button>
            </div>
          </div>
        </div>
      </template>
      <div :class="['c-cbr-MapOverlay-mapContainer',$style.mapDiv]">
        <v-map
          :center="coordinates"
          :zoom="zoomLevel">
          <v-tilelayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" />
          <v-marker
            v-for="(item, key) in computedMarkers"
            :key="key"
            :draggable="false"
            :icon="item.icon"
            :lat-lng="item.position"
            @l-click="selectDropShopById(item.id);scrollToShop(item.id);"
          >
            <v-tooltip :content="item.tooltip" />
          </v-marker>
        </v-map>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import CbrModal from './CbrModal.vue'
import CbrDropShopMini from './drop-shop/CbrDropShopMini.vue'
import ObjButton from './ObjButton.vue'
import ObjLink from './ObjLink.vue'
import ObjLinkDefault from './ObjLinkDefault.vue'
import ObjSpinner from './ObjSpinner.vue'
import CbrNavigation from './CbrNavigation.vue'
import { i18nIsoCountriesVar } from '../store/modules/config/index'
import { countryHasParcelShops } from '../../static/countriesWithParcelShops'
import { getCountrySpecificUrl } from '../../static/parcelshopSearchURLs'
import { eventBus } from '../app'

export default {
  components: {
    CbrModal,
    ObjButton,
    ObjLink,
    ObjLinkDefault,
    CbrDropShopMini,
    ObjSpinner,
    CbrNavigation,
    eventBus
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      distance: 5000,
      defaultCountries: null,
      selectedCountry: 'Sudan', //for default as it would return no parcelshops
      dropShop: {
        style:
          'fill:#6b1544;fill-rule:nonzero;stroke:#6b1544;stroke-width:1px;',
        fill: 'white'
      },
      dropShopSelected: {
        style: 'fill: #FFF;fill-rule:nonzero;stroke:#6b1544;stroke-width:1.5px;',
        fill: '#6b1544'
      },
      mapSearchFormData: {},
      distanceOptions: [
        { text: '500 m', value: 500 },
        { text: '1 km', value: 1000 },
        { text: '2 km', value: 2000 },
        { text: '5 km', value: 5000 },
        { text: '10 km', value: 10000 },
        { text: '20 km', value: 20000 },
        { text: '50 km', value: 50000 }
      ],
      inputAddress: null,
      resultLimit: 25,
      pendingRequests: 0,
      addressHasError: false,
      countryHasError: false,
      searchDivMinimized: false,
      showHint: false,
      langChanged: false

    }
  },

  computed: {
    ...mapState('dropShops', ['markers', 'lat', 'lng', 'dropShops']),
    ...mapState('inputData', ['formData', 'formDataCountry']),
    ...mapGetters('dropShops', ['selectedDropShop']),
    ...mapGetters('config', [
      'buttonColor',
      'buttonTextColor',
      'fieldTextColor',
      'pageTextColor',
      'countries',
      'allCountries',
      'countriesWithParcelShopsInDB',
    ]),

    getCountryList() {
      if (Object.keys(this.countries).length === 0) {
        return this.allCountries
      } else {
        return this.countries
      }
    },

    getSelectedCountryAlpha2Code() {
      return i18nIsoCountriesVar.getAlpha2Code(this.selectedCountry, this.currentLanguage)
    },

    getSelectedCountryURL() {
      return getCountrySpecificUrl(this.getSelectedCountryAlpha2Code);
    },

    countryHasParcelShops() {
      return countryHasParcelShops(this.getSelectedCountryAlpha2Code);
    },

    currentLanguage: {
      get: function() {
          return this.$store.state.lang.currentLanguage
        },
      set: function(val) {
          this.languageSelect(val)
        }
      },

    address: {
      get() {
        return this.inputAddress
      },

      set(address) {
        this.inputAddress = address
      }
    },

    zoomLevel() {
      /* Handle address not found */
      if (!this.selectedDropShop) {
        return 4
      }

      const distance = this.distance

      /* Default zoomlevel === 20 for europe focus */
      let zoomLevel = 20
        if (distance == 50000) {
        zoomLevel = 9.5
      } else if (distance == 20000) {
        zoomLevel = 10.5
      } else if (distance == 10000) {
        zoomLevel = 11.5
      } else if (distance == 5000) {
        zoomLevel = 12.5
      } else if (distance == 2000) {
        zoomLevel = 13.5
      } else if (distance == 1000) {
        zoomLevel = 14.5
      } else if (distance == 500) {
        zoomLevel = 15.5
      }

      return zoomLevel
    },

    computedMarkers() {
      if (!this.markers) {
        return false
      }

      let markerArray = this.markers.map(marker => {
        if (marker.id === this.selectedDropShop.id) {
          marker.type = 'dropShopSelected'
          marker.icon = this.markerIcon(
            this.dropShop.style,
            this.dropShop.fill,
            marker.number
          )
        } else if (marker.id !== 1) {
          marker.type = 'dropShop'
          marker.icon = this.markerIcon(
            this.dropShopSelected.style,
            this.dropShopSelected.fill,
            marker.number
          )
        }

        return marker
      })
      let homeLocation = markerArray[markerArray.length - 1]
      markerArray.unshift(homeLocation)
      return markerArray.slice(0, this.resultLimit + 1)
    },

    coordinates() {
      return this.calculateCoordinates()
    }
  },
  created() {

    this.preSelectCountry();

    eventBus.$on('keepSelectedCountry', () => {
    /*TODO:
     Keep the selectedCountry on language change - synchronize translated country <=> selectedCountry.
     -> this.selectedCountry = i18nIsoCountriesVar.getName(this.getSelectedCountryAlpha2Code, this.currentLanguage) <-
     .. does not work, because the Alpha2Code of the selectedCountry will not match the currentLanguage.
     Workaround: the showHint flag will be set to false on language change, so the country specific URL will not be shown
     in the results box. This prevents a dead link to be shown if the selectedCountry was UK before the language change. */
      this.showHint = false;
      this.langChanged = true;


    }),
    Object.keys(this.countries).length === 0
      ? (this.defaultCountries = this.allCountries)
      : (this.defaultCountries = this.countries)

    if (this.buttonColor !== '') {
      this.dropShop.style =
        'fill:' +
        this.buttonColor +
        ';fill-rule:nonzero;stroke:' +
        this.buttonColor +
        ';stroke-width:1px;'
      this.dropShopSelected.style =
        'fill: #FFF;fill-rule:nonzero;stroke:' +
        this.buttonColor +
        ';stroke-width:2px;'
    }
    if (this.buttonTextColor !== '') {
      this.dropShop.fill = this.buttonTextColor
      this.dropShopSelected.fill = '#000000'
    }

    if (this.$route.query.address && this.$route.query.country) {
      this.address = this.$route.query.address
      this.search()
    }
  },
  updated: function() {
    //this.preSelectCountry();
    /* Calculate the height of the shop list */
    const shopSelected = document.getElementById(
      'c-cbr-MapOverlay-results-shopSelected'
    )
    const shopList = document.getElementById(
      'c-cbr-MapOverlay-results-shopList'
    )
    if (shopSelected && shopList) {
      const selectedHeight = shopSelected.offsetHeight
      const listHeight = `calc( 100% - ${selectedHeight + 20}px`
      shopList.style.height = listHeight
    }
  },

  methods: {
    ...mapMutations('dropShops', [
      'SET_SELECTED_DROP_SHOP',
      'SET_DISTANCE',
      'SET_ADDRESS',
      'SET_COUNTRY'
    ]),

    ...mapActions('dropShops', [
      'selectDropShopById',
      'searchDropShops',
      'resetDropshops'
    ]),

    ...mapActions('lang', ['languageSelect']),

    /*ToDo Keep the selected country in the dropdown selection.
    keepSelectedCountry() {

    },*/


    preSelectCountry(){

      if (this.$route.query.country && this.$route.query.locale) {
      this.languageSelect(this.$route.query.locale)
      this.selectedCountry = i18nIsoCountriesVar.getName(
        this.$route.query.country,
        this.currentLanguage
      )
    } else if (this.$route.query.locale) {
      this.languageSelect(this.$route.query.locale.slice(0,2))
      this.selectedCountry = i18nIsoCountriesVar.getName(
        this.$route.query.locale.slice(-2),
        this.currentLanguage
      )
    } else if (this.$route.query.country) {
      this.address = this.$route.query.address
      this.selectedCountry = i18nIsoCountriesVar.getName(
        this.$route.query.country,
        this.currentLanguage
      )
    } else {
       switch (this.currentLanguage) {
         case 'en': this.selectedCountry = i18nIsoCountriesVar.getName('GB', this.currentLanguage);
         break;
         case 'da': this.selectedCountry = i18nIsoCountriesVar.getName('DK', this.currentLanguage);
         break;
         case 'cs': this.selectedCountry = i18nIsoCountriesVar.getName('CZ', this.currentLanguage);
         break;
         case 'sl': this.selectedCountry = i18nIsoCountriesVar.getName('SI', this.currentLanguage);
         break;
         default: this.selectedCountry = i18nIsoCountriesVar.getName(navigator.language.slice(-2).toUpperCase(), this.currentLanguage) || 'Sudan';
       }
    }
  },

    markerIcon(style, fill, number) {
      return L.divIcon({
        iconSize: new L.Point(50, 50),
        html: `<div class="markerIcon"><svg width="100%" height="100%" viewBox="0 0 28 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><rect id="pin" x="0" y="0" width="27.143" height="38" style="fill:none;"/><clipPath id="_clip1"><rect x="0" y="0" width="27.143" height="38"/></clipPath><g clip-path="url(#_clip1)"><g id="pin1" serif:id="pin"><rect id="EXPORT" x="-2352.67" y="-1805.5" width="6611.8" height="5215.4" style="fill:none;"/><path d="M13.6,0.5c-7.242,0 -13.1,5.745 -13.1,12.848c0,9.636 13.1,23.861 13.1,23.861c0,0 13.1,-14.225 13.1,-23.861c0,-7.103 -5.858,-12.848 -13.1,-12.848Z" style="${style}"/></g></g><text text-anchor="middle" x="13" y="21" font-size="14px" fill="${fill}">${number}</text></svg></div>`
      })
    },

    //     markerIcon(style, fill, number, isSelected) {

    //       if(isSelected){
    //   return L.divIcon({
    //     iconSize: new L.Point(50, 50),
    //     html: `<div class="markerIcon"><img src="/assets/glsLogoPin.png"</div>`
    //   })
    //       }
    //       else{
    //   return L.divIcon({
    //     iconSize: new L.Point(50, 50),
    //     html: `<div class="markerIcon"><img  src="/assets/glsLogoPin.png" class="upanddown"</div>`
    //   })}
    // },

    calculateCoordinates() {
      //to have europe in the centre of the map in the beginning
      let lat = 48
      let lng = 9

      if (this.selectedDropShop) {
        lat = this.selectedDropShop.address.latitude
        lng = this.selectedDropShop.address.longitude
      } else if (this.lat && this.lng) {
        lat = this.lat
        lng = this.lng
      }

      return [lat, lng]
    },

    search() {
      if (this.langChanged) {
        this.selectedCountry = 'Sudan'
      }
      if (this.address === null || this.selectedCountry === 'Sudan') {
        this.address === null
          ? (this.addressHasError = true)
          : (this.addressHasError = false)
          this.langChanged = false
        this.selectedCountry === 'Sudan'
          ? (this.countryHasError = true)
          : (this.countryHasError = false)
          this.langChanged = false
      } else {
        this.addressHasError = false
        this.countryHasError = false
        this.langChanged = false
        this.SET_DISTANCE(this.distance)
        this.SET_ADDRESS(this.address + ',' + this.selectedCountry)
        this.SET_COUNTRY( i18nIsoCountriesVar.getAlpha2Code(this.selectedCountry,this.currentLanguage))
        this.pendingRequests = this.pendingRequests + 1
        this.showHint = true;
        this.searchDropShops().then(() => {
          this.pendingRequests = 0
          if (this.selectedDropShop) {
            this.searchDivMinimized = true
          }
        })
      }
    },

    showMore() {
      this.resultLimit += 25
    },

    setCountry(country) {
      this.selectedCountry = country
      this.langChanged = false
      this.showHint = true
    },
    scrollToShop(id) {
      var elmnt = document.getElementById(id)
      elmnt.scrollIntoView()
    },
    maximiseSearchDiv() {
      this.searchDivMinimized = false
      this.address = null;
    }
  }
}
</script>

<style module>
.sorryMsg {
  text-align: center;
}

.map {
  cursor: pointer;
}

.closeIcon {
  width: 50px;
  height: 50px;
  background-image: url('../../assets/ico_close.svg');
}

.showMore {
  text-align: center;
  margin: 1.25rem;
}

.showMapInner {
  width: 100%;
  grid-template-columns: 40% 60%;
  @media (max-width: 600px) {
    grid-template-columns: auto;
  }
}

.dropdown {
  display: grid;
  grid-template-columns: 50% auto;
  grid-column-gap: 1rem;
}

.buttonDiv {
  margin-top: 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.addressField {
  display: grid;
  grid-template-columns: 60% 40%;
  grid-gap: 5px;
}

.mapDiv{
  grid-column: 2;
  @media (max-width: 600px) {
     grid-column: 1;
  }
}

.searchBoxDiv{
   grid-column: 1;
   padding-bottom: 1.5em;
   padding-top: 1.5em;

}

.resultsDiv{
   grid-column: 1;
      padding-left: 1rem;
    padding-right: 1rem;
}

.errorMsg{
   grid-column: 1;
   padding: 2rem;
}
</style>



// WEBPACK FOOTER //
// client/components/CbrSoloMap.vue